import type { OapPaymentPlan } from '@/types'

// Sepio payment plans for stage and production
const sepioPlans = {
	stage: [
		{
			id: 'plan_SMfRooNkYVaiER',
			title: 'Single Payment - $499',
			price: 499,
			pricePointId: '68307e7c3715c81b40a4c272',
			paymentCount: 1,
		},
		{
			id: 'plan_SMfR7hV2cKhUCU',
			title: '12 Month - $50',
			price: 50,
			pricePointId: '68307e7c3715c81b40a4c272',
			paymentCount: 12,
		},
		{
			id: 'plan_SlVpByPdSSEQ31',
			title: '3 Month - $167',
			price: 167,
			pricePointId: '68307e7c3715c81b40a4c272',
			paymentCount: 3,
		},
	],
	prod: [
		// $499 base price
		{
			id: 'plan_SlotC7BbFutAUE',
			title: 'Single Payment - $499',
			price: 499,
			pricePointId: '6888ee1e6e2dc67cd94509d4',
			paymentCount: 1,
		},
		{
			id: 'plan_Slov1uvEf39GtE',
			title: '12 Month - $50',
			price: 50,
			pricePointId: '6888ee1e6e2dc67cd94509d4',
			paymentCount: 12,
		},
		{
			id: 'plan_SlouuyN8Jmp2qN',
			title: '3 Month - $167',
			price: 167,
			pricePointId: '6888ee1e6e2dc67cd94509d4',
			paymentCount: 3,
		},

		// $599 base price (CS - Carriage)
		{
			id: 'plan_T1vEUG3Dr6NTpD',
			title: 'Single Payment - $599 (CS)',
			price: 599,
			pricePointId: '688a36c12f97ecab7bfdf3d6',
			paymentCount: 1,
		},
		{
			id: 'plan_SrSZOnVWF1pK7v',
			title: '12 Month - $55 (CS)',
			price: 55,
			pricePointId: '688a36c12f97ecab7bfdf3d6',
			paymentCount: 12,
		},

		// $549 base price (FPG)
		{
			id: 'plan_T2jAYNgYtulU3c',
			title: 'Single Payment - $549 (FPG)',
			price: 549,
			pricePointId: '688a36a12f97ecab7bfdf3d5',
			paymentCount: 1,
		},
		{
			id: 'plan_T1vB5CeNmpPcPr',
			title: '3 Month - $183 (FPG)',
			price: 183,
			pricePointId: '688a36a12f97ecab7bfdf3d5',
			paymentCount: 3,
		},
		{
			id: 'plan_StMNQvflKflv5l',
			title: '12 Month - $50 (FPG)',
			price: 50,
			pricePointId: '688a36a12f97ecab7bfdf3d5',
			paymentCount: 12,
		},
	],
}

const useProd = import.meta.env.VITE_USE_PROD_SEPIO_PLANS === 'true'

// Set Sepio OAP payment options depending on VITE_USE_PROD_SEPIO_PLANS env variable
export const sepioOapPaymentOptions: OapPaymentPlan[] = useProd
	? sepioPlans.prod
	: sepioPlans.stage
